import AttendanceService from "./AttendanceService";

const getAll = async (date, divisionCode) => {
  try {
    const res = await AttendanceService.GetEmpLocationCount(divisionCode,date);
    const list = res?.data?.Data || res?.data?.ResultSet || res?.data || [];
    return list.map((item) => ({
      Emp_location: item.Emp_location,
      Emp_Total: item.Emp_Total,
      Emp_real: item.Emp_real,
      Percentage: item.Percentage,
      Emp_Out: item.Emp_Out,
      Emp_Available: item.Emp_Available,
      Out_Percentage: item.Out_Percentage,
      Available_Percentage: item.Available_Percentage,
    }));
  } catch (error) {
    console.error("Error in EmployeeAttendanceService.getAll:", error);
    throw error;
  }
};

const getEmpByLocation = async (date, locationCode, divisionCode) => {
  try {
    const empRes = await AttendanceService.GetEmployeesAttendance(
      divisionCode,
      locationCode,
      date
    );
    const employees = empRes?.data?.ResultSet || empRes?.data || [];
    return employees.map((emp) => ({
      serviceNo: emp.ServiceNo,
      name: emp.EmployeeName,
      designation: emp.Designation,
      inTime: emp.InTime && String(emp.InTime).trim().toLowerCase() !== "nr" ? emp.InTime : null,
      outTime: emp.OutTime && String(emp.OutTime).trim().toLowerCase() !== "nr" ? emp.OutTime : null,
    }));
  } catch (error) {
    console.error("Error in EmployeeAttendanceService.getEmpByLocation:", error);
    throw error;
  }
};

export default { getAll, getEmpByLocation };